import { render, staticRenderFns } from "./Embroidery.vue?vue&type=template&id=1a6a0a44&scoped=true"
import script from "./Embroidery.vue?vue&type=script&lang=js"
export * from "./Embroidery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6a0a44",
  null
  
)

export default component.exports